export default __webpack_public_path__ + "static/media/Pegasus1.68b80696.png";